"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Can = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _underscore = _interopRequireDefault(require("underscore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _entitlements = require("@contently/entitlements");

var _toggleable = require("../toggleable");

var _internal = require("../../internal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Can = /*#__PURE__*/function (_Component) {
  _inherits(Can, _Component);

  var _super = _createSuper(Can);

  function Can(props) {
    var _this;

    _classCallCheck(this, Can);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "checkIsEntitled", function () {
      var _this$props = _this.props,
          permission = _this$props.permission,
          permissionsMap = _this$props.permissionsMap;

      var mappedEntitlements = _entitlements.EntitlementMapper.load(permissionsMap);

      mappedEntitlements.isEntitled(permission).then(function (result) {
        _this.setState({
          enabled: result
        });
      });
    });

    _this.state = {
      enabled: false
    };
    return _this;
  }

  _createClass(Can, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkIsEntitled();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var permissionsMap = this.props.permissionsMap;

      if (!_underscore.default.isEqual(prevProps.permissionsMap, permissionsMap)) {
        this.checkIsEntitled();
      }
    }
  }, {
    key: "enabledValue",
    value: function enabledValue() {
      var enabled = this.state.enabled;
      return enabled;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          permission = _this$props2.permission,
          permissionsMap = _this$props2.permissionsMap;

      if (!permissionsMap) {
        return /*#__PURE__*/_react.default.createElement(_internal.ComponentError, null, "Entitlements is required");
      }

      if (!permission) {
        return /*#__PURE__*/_react.default.createElement(_internal.ComponentError, null, "No permission was specified");
      }

      return /*#__PURE__*/_react.default.createElement(_toggleable.Toggleable, {
        show: this.enabledValue()
      }, children);
    }
  }]);

  return Can;
}(_react.Component);

exports.Can = Can;

var mapStateToProps = function mapStateToProps(state) {
  var permissionsMap = state.entitlements.permissionsMap;
  return {
    permissionsMap: permissionsMap
  };
};

Can.propTypes = {
  permissionsMap: _propTypes.default.shape({}).isRequired,
  permission: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]).isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Can);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/can/Can.js
// module id = 343
// module chunks = 0 15 16 17 18